import { render, staticRenderFns } from "./user-profile-display.vue?vue&type=template&id=3b3b3f0e"
import script from "./user-profile-display.vue?vue&type=script&lang=js"
export * from "./user-profile-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports